<template>
  <el-row>
    <el-row class="bottom20">
      <el-table ref="table" :data="page.records" :stripe="true" :highlight-current-row="true" style="width: 100%">
        <el-table-column prop="code" label="用户">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">用户</span><br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope" >
              {{scope.row.valueObject.contract.enduser != null ? scope.row.valueObject.contract.enduser.name : scope.row.valueObject.contract.endUserId}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="合同名称">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">名称</span><br>
            <el-input size="mini" v-model="pageSearch.search.like_contractName">
            </el-input>
          </template>
          <template slot-scope="scope" >
            <a href="javascript: void(0);" @click="toLook(scope.row)">
              {{scope.row.valueObject.contract.name}}
            </a>
          </template>
        </el-table-column>
        <el-table-column  label="合同编号" >
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">合同编号</span><br>
            <el-input size="mini" v-model="pageSearch.search.like_contractSid">
            </el-input>
          </template>
          <template slot-scope="scope" >
            <span>
              {{scope.row.valueObject.contract.sid}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="操作时间">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">操作时间</span><br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.lastUpdateTime}}
          </template>
        </el-table-column>
        <el-table-column prop="lastUpdateUserId" label="操作人">
          <template slot="header" slot-scope="scope">
            <span v-if="scope != null">操作人</span><br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope" >
            {{scope.row.lastUpdateUserRealName}}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination @current-change="setPageSearchCurrent"
                     @size-change="setPageSearchSize"
                     :current-page="pageSearch.current"
                     :page-size="pageSearch.size"
                     :page-sizes="[10, 25, 50, 100]"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="page.total">
      </el-pagination>
    </el-row>
  </el-row>
</template>

<script>
import _ from 'lodash';
import DataRecordApi from "@/api/billing/data-record-api";
import {handleError} from "@/util/error-util";
import {PersonServer} from "@/api";
import {getPersonsByIds} from "@/views/billing/contract/record/contract-record-common";

export default {
  name: "contract-record-page",
  data() {
    return {
      pageSearch: {
        current: 1,
        size: 10,
        search: {
          eq_contractId: null,
          like_contractName: null,
          like_contractSid: null,
          in_status: [0, 1], // 草稿, 已确认，不查询已回滚（2）
        },
      },
      page: {
        total: 0,
        records: [],
      },
    };
  },
  watch: {
    'pageSearch.current': {
      deep: false,
      immediate: false,
      handler() {
        this.queryByPage();
      },
    },
    'pageSearch.size': {
      deep: false,
      immediate: false,
      handler() {
        this.reQueryByPage();
      },
    },
    'pageSearch.search': {
      deep: true,
      immediate: false,
      handler() {
        this.reQueryByPage();
      }
    },
    'page': {
      deep: true,
      immediate: false,
      handler() {
        let page = this.page, records = page.records;
        if (records.length > 0) {
          this.$emit('first-change', records[0]);
        }
      }
    }
  },
  methods: {
    setPageSearchCurrent(current) {
      this.pageSearch.current = current;
    },
    setPageSearchSize(size) {
      this.pageSearch.size = size;
    },
    setPage(page) {
      this.page = page;
    },
    reQueryByPage() {
      if (this.pageSearch.current === 1) {
        this.queryByPage();
      } else {
        this.setPageSearchCurrent(1);
      }
    },
    async doQueryByPage() {
      let page = {total: 0, records: []};
      let pageSearch = this.pageSearch;
      let response;
      try {
        response = await DataRecordApi.page(pageSearch);
      } catch (e) {
        handleError(e);
      }
      if (response.data.success) {
        let total = response.data.data.total;
        let records = response.data.data.records;
        let lastUpdateUserIds = _.uniq(_.filter(_.map(records, e => e.lastUpdateUserId), e => e != null));
        let persons = await getPersonsByIds(lastUpdateUserIds);
        let personsMap = _.keyBy(persons, e => 'person_' + e.personuid);
        for (let i = 0, len = records.length; i < len; i++) {
          let record = records[i];
          let person = personsMap['person_' + record.lastUpdateUserId];
          record.lastUpdateUserRealName = person == null ? record.lastUpdateUserId : person.realname;
          record.valueObject = JSON.parse(record.value);
        }
        page = {
          total: total,
          records: records,
        };
      } else {
        this.$message.error(response.data.responseMessage);
      }
      this.page = page;
    },
    queryByPage: _.debounce( function () {
      this.doQueryByPage();
    }, 100),
    async query() {
      this.reQueryByPage();
    },
    setCurrentRow(row) {
      this.$refs.table.setCurrentRow(row);
    },
    toLook(data) {
      this.setCurrentRow(data);
      this.$emit('to-look', data.id);
    },
  },
}
</script>

<style scoped>

</style>